// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","438":"2d36dd80","453":"component---src-pages-404-tsx","624":"fb7d5399"}[chunkId] + "-" + {"245":"2768bda8cb70ca3074a7","438":"8279ae2a84faca1af7b1","453":"b61e60925e62c6a3badc","624":"5690869c7228fe932cfd"}[chunkId] + ".js";
};